var _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.7143,
    height: 25.7143,
    rx: 3.85714,
    fill: "#0B60D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.321429,
    y: 0.321429,
    width: 25.0714,
    height: 25.0714,
    rx: 3.53571,
    fill: "#0B60D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.321429,
    y: 0.321429,
    width: 25.0714,
    height: 25.0714,
    rx: 3.53571,
    stroke: "#0B60D6",
    strokeWidth: 0.642857
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8527 10.2852V15.428M15.4241 12.8566H10.2812",
    stroke: "white",
    strokeWidth: 0.964286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8504 19.2868C16.4008 19.2868 19.279 16.4087 19.279 12.8583C19.279 9.30786 16.4008 6.42969 12.8504 6.42969C9.30004 6.42969 6.42188 9.30786 6.42188 12.8583C6.42188 16.4087 9.30004 19.2868 12.8504 19.2868Z",
    stroke: "white",
    strokeWidth: 0.964286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5df512593d66b53f2c8c5dcf75871a24.svg";
export { ForwardRef as ReactComponent };